import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/client'
import { useNavigate } from 'react-router-dom'
import Loading from '@orionx-dev/orionsoft-parts/lib/components/Loading'
import Card from 'src/stories/Card'
import gql from 'graphql-tag'

let called = false

const VerifyLogin = () => {
  const navigate = useNavigate()
  const [errMessage, setErrMessage] = useState('')

  const [authorizeSession] = useMutation(gql`
    mutation authorizeSession($code: String) {
      authorizeSession(code: $code) {
        success
      }
    }
  `)

  useEffect(() => {
    const pathname = window.location.pathname
    const code = pathname.replace('/verify-login/', '')
    const fetchData = async () => {
      if (called) return
      called = true
      try {
        const response = await authorizeSession({ variables: { code }, refetchQueries: ['getMe'] })
        if (response.data.authorizeSession.success) {
          const path = localStorage.getItem('nextPathname') || '/accounts'
          localStorage.setItem('nextPathname', '')
          console.log('going to', path)
          navigate(path)
        }
      } catch (err) {
        console.error('there was an error', err)
        setErrMessage(err.message.replace(/GraphQL error: (.*) \[.*\]/g, '$1'))
      }
    }
    console.log(fetchData)

    fetchData()
  }, [authorizeSession, navigate])

  const handleLogout = async () => {
    navigate('/login')
  }

  const errorMessage = (
    <div>
      <p className="p-2 text-red-600">
        Ocurrió un error al iniciar sesión
        <br />
        {errMessage}
      </p>
      <p>
        <a onClick={handleLogout}>Volver al Login</a>
      </p>
    </div>
  )

  return (
    <div className="absolute overflow-x-hidden w-full h-full top-0 left-0 bg-ox-blue-950 dark:bg-ox-blue-950 flex items-center justify-center">
      <Card title="Validando dispositivo" className="w-full mx-4 md:w-1/2">
        {errMessage ? errorMessage : <Loading />}
      </Card>
    </div>
  )
}

VerifyLogin.whyDidYouRender = {
  logOnDifferentValues: true,
}

VerifyLogin.propTypes = {
  router: PropTypes.object,
  authorizeSession: PropTypes.func,
  client: PropTypes.object,
}

export default VerifyLogin
